import { injectIntl } from "react-intl";
import React, { memo, useEffect } from "react";
import { useDispatch, useSelector} from "react-redux";
import { 
    sendMfaSms, 
    sendMfaMail,
    selectMfaStatus, 
    selectMfaErrorMessage,
    selectMfaMailStatus,
    selectMfaMailErrorMessage,
    resetMfaStatus 
} from "../../redux";

import { ReduxState } from "../../../../redux/types";
import { Formik } from 'formik';

function Mfa() {
    const dispatch = useDispatch();

    // SMS用の状態
    const mfaStatus = useSelector(selectMfaStatus);
    const mfaErrorMessage = useSelector(selectMfaErrorMessage);

    // メール用の状態
    const mfaMailStatus = useSelector(selectMfaMailStatus);
    const mfaMailErrorMessage = useSelector(selectMfaMailErrorMessage);

    // 表示初期化
    useEffect(() => {
        dispatch(resetMfaStatus());
    }, [dispatch]);

    // 認証方式の初期値（デフォルトでSMS「1」を選択状態に）
    const initialValues = {
        authType: '1'
    };

    const onSubmit = (values, { setSubmitting }) => {
        // どちらかの送信を開始する前に、前回の古いエラーメッセージを一旦クリア
        dispatch(resetMfaStatus());

        if (values.authType === '1') {
            // SMS（ショートメッセージ）が選択された場合
            dispatch(sendMfaSms({ authType: values.authType, setSubmitting }));
        } else if (values.authType === '2') {
            // メールが選択された場合
            dispatch(sendMfaMail({ authType: values.authType, setSubmitting }));
        }
    };

    // 二重表示防止：SMS側、またはメール側のいずれかでエラーがあれば、そのメッセージを採用する
    const hasError = mfaStatus === ReduxState.ERROR || mfaMailStatus === ReduxState.ERROR;
    const activeErrorMessage = mfaErrorMessage || mfaMailErrorMessage;

    return (
        <div>
            {/* ★全画面読み込みの confetti.js に要素を掴ませて、エラー回避のダミー */}
            <canvas id="confetti" style={{ display: 'none' }}></canvas>
            <div className="m-pager-title">
                <div className="m-pager-title__inner">
                    <p className="m-pager-title__inner__title">認証＞認証方式選択</p>
                </div>
            </div>
            <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
            >
                {propsFormik => (
                    <form id="form" onSubmit={propsFormik.handleSubmit}>
                        <div className="t-contents t-contents--bg-ivory">
                            <div className="o-entry" ref={el => el && el.style.setProperty('max-width', '700px', 'important')}>
                                <p className="has-text-centered u-mb15" style={{ color: "#ff0000"}}>
                                    本ページでは、ポイントや会員情報を安全にお守りするため、認証コードによる本人確認を行っています。
                                    <br />
                                </p>
                                <p
                                    className="m-animal-header__normal-title u-mb5"
                                    style={{ color: "#333", fontWeight: 'normal' ,fontSize:"16px"}}>
                                    認証コードの受取方法を選び、送信するボタンをクリックしてください。
                                </p>
                                <p
                                    className="m-animal-header__normal-title u-mb10"
                                    style={{ color: "#333", fontWeight: 'normal' ,fontSize:"16px"}}>
                                    認証コードは、モニター情報に登録されている電話番号またはメールアドレス宛てに送信します。
                                </p>
                                <p
                                    className="m-animal-header__normal-title u-mb5"
                                    style={{ color: "#333" }}
                                >
                                    認証方式選択
                                </p>
                            </div>

                            <div className="a-input-select a-input-select--area a-button--pc-w330 responsive-select-wrapper">
                                <select 
                                    value={propsFormik.values.authType}
                                    onChange={(e) => propsFormik.setFieldValue('authType', e.target.value)}
                                    className="a-input-select__list"
                                    name="authType"
                                >
                                    <option value="1">SMS（ショートメッセージ）で受け取る</option>
                                    <option value="2">メールで受け取る</option>
                                </select>
                            </div>

                            {/* 【A2-1 送信エラーメッセージ表示エリア（1箇所に完全統合）】 */}
                            {hasError && activeErrorMessage && (
                                <p className="has-text-centered" style={{ color: "rgb(255, 0, 0)", marginTop: "20px" }}>
                                    {activeErrorMessage}
                                </p>
                            )}

                            <div className="o-entry" style={{ marginTop: 60 }}>
                                <button
                                    type="submit"
                                    disabled={propsFormik.isSubmitting} // ★追加：連打（二重送信）防止
                                    style={{ cursor: propsFormik.isSubmitting ? 'not-allowed' : 'pointer', border: 'none', display: 'block', margin: '0 auto' }}
                                    className="a-button a-button--submit a-button--pc-w330 a-button--round u-fz16"
                                >
                                    {propsFormik.isSubmitting ? "送信中..." : "送信する"}
                                </button>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
}

export default memo(injectIntl(Mfa));